import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import React, { useEffect, useRef, useState } from "react";

import Carousel, {
  RenderArrowProps,
  RenderPaginationProps,
} from "react-elastic-carousel";

import { Grid, IconButton, Tooltip } from "@material-ui/core";
import {
  Adjust,
  Circle,
  Close,
  Mail,
  Print,
  Visibility,
  VisibilityOff,
} from "@material-ui/icons";
import { ArrowCircleLeft, ArrowCircleRight } from "@mui/icons-material";
import { Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useKeyPress } from "@react-typed-hooks/use-key-press";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { useSnackbar } from "../../core/contexts/SnackbarProvider";
import { User } from "../../users/types/user";
import { execSelectionOptions, getCandidateInfo } from "../hooks/useCandidate";
import { getUser } from "../infra/getUser";
import Curricullum from "./Curricullum";
import ModalNoProfile from "./ModalNoProfile";
import ModalSelectCan from "./ModalSelectCan";
import ModalSendCandidateToVacancy from "./ModalSendCandidateToVacancy";

const useStyles = makeStyles({
  visible: {
    "&:hover": {
      color: "#27b279",
    },
  },
  arrows: {
    "&:hover": {
      color: "#27b279",
      cursor: "pointer",
    },
  },
  arrowsLeft: {
    position: "fixed",
    zIndex: 4,
    top: "40vh",
    "&:hover": {
      color: "#27b279",
      cursor: "pointer",
    },
  },
  arrowsRight: {
    position: "fixed",
    zIndex: 4,
    marginLeft: -95,
    top: "40vh",
    "&:hover": {
      color: "#27b279",
      cursor: "pointer",
    },
  },
});

type UserDialogProps = {
  onAdd: (user: Partial<User>) => void;
  onClose: () => void;
  onUpdate: (user: User) => void;
  setCanId: (number: number) => void;
  setModalCVIndex: (number: number) => void;
  setModalCVAutoHCode: (number: number) => void;
  open: boolean;
  title: string;
  wData: any;
  processing: boolean;
  modalIndex: number;
  canId?: number;
  user?: User;
  vacancyId?: number;
  modalCVAutoHCode?: number;
  slideFromLeft?: boolean;
  isMLTab?: boolean;
  onMLCandidateProcessed?: (candidatoId: number) => void;
};

const renderPrev = (active: number, initState: any) => {
  const sum = active - 1;
  if (sum == -1) {
    return;
  }
  return (
    <>
      <div className="statusTop">
        <ArrowCircleLeft />
        Anterior
      </div>
      <>{initState[sum].pessoal_nome}</>
    </>
  );
};

const renderNext = (active: number, initState: any) => {
  const sum = active + 1;
  const arrayLen = initState.length;
  if (sum >= arrayLen) {
    return;
  }
  return (
    <>
      <div className="statusTop">
        Próximo <ArrowCircleRight />
      </div>
      <>{initState[sum].pessoal_nome}</>
    </>
  );
};

const ModalCVSelection = ({
  onAdd,
  onClose,
  onUpdate,
  setCanId,
  setModalCVIndex,
  setModalCVAutoHCode,
  open,
  title,
  wData,
  processing,
  modalIndex,
  canId,
  user,
  vacancyId,
  modalCVAutoHCode,
  slideFromLeft = false,
  isMLTab = false,
  onMLCandidateProcessed,
}: UserDialogProps) => {
  const classes = useStyles();

  const handleSubmit = (values: Partial<User>) => {
    if (user && user.id) {
      onUpdate({ ...values, id: user.id } as User);
    } else {
      onAdd(values);
    }
  };
  const vacnacyIdCod = vacancyId;
  const [initState, setInitState] = React.useState<any[]>([]);
  const [noProfileArray, setNoProfileArray] = React.useState<any[]>([]);
  const [selectedeArray, setSelectedArray] = React.useState<any[]>([]);
  const [obse, handleObse] = React.useState<boolean>(false);
  const [modalNoProfile, handleModalNoProfile] = React.useState<boolean>(false);
  const [modalSendCanidateToVacancy, handleModalSendCanidateToVacancy] =
    React.useState<boolean>(false);
  const [modalSelectCan, handleModalSelectCan] = React.useState<boolean>(false);

  const [indexState, setIndexState] = React.useState(modalIndex);
  const [reload, setReload] = React.useState(false);

  const [pessoalData, setPessoalData] = useState<any>();
  const [isLoadingCV, seLoadingCV] = React.useState<boolean>(false);

  const getCanInfo = async () => {
    if (canId != 0) {
      seLoadingCV(true);
      await getCandidateInfo(canId).then((res) => {
        setPessoalData(res);
      });
      seLoadingCV(false);
    }
  };

  useEffect(() => {
    setPessoalData({});
    getCanInfo();
  }, [canId]);

  useEffect(() => {
    setInitState(wData);
  }, [wData]);

  useEffect(() => {
    setIndexState(modalIndex);
    setReload(true);
    setTimeout(() => {
      setReload(false);
    }, 1);
  }, [modalIndex]);

  const isLeftPressed = useKeyPress({ targetKey: "ArrowLeft" });
  const isRigthtPressed = useKeyPress({ targetKey: "ArrowRight" });
  const buttonRefLeft = useRef<HTMLButtonElement>(null);
  const buttonRefRigtht = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isLeftPressed) {
      if (buttonRefLeft && buttonRefLeft.current) {
        buttonRefLeft.current.click(); // Trigger click event
      }
    }
  }, [isLeftPressed]);

  useEffect(() => {
    if (isRigthtPressed) {
      if (buttonRefRigtht && buttonRefRigtht.current) {
        buttonRefRigtht.current.click(); // Trigger click event
      }
    }
  }, [isRigthtPressed]);

  const renderActive = (active: number) => {
    const sum = active;
    setCanId(initState[sum].id);
    setIndexState(active);
    setModalCVAutoHCode(initState[sum].autohis_codigo);
    return (
      <>
        <div className="statusTopVisu">Visualizando:</div>
        <div className="statusTopText">{initState[sum].pessoal_nome}</div>
      </>
    );
  };
  const snackbar = useSnackbar();
  const handleExecSele = async (
    id: number | undefined,
    type: number,
    vacancyId?: number | undefined,
    modalCVAutoHCode?: number | undefined
  ) => {
    let body;
    if (type == 1) {
      body = {
        type: type,
        modalCVAutoHCode: modalCVAutoHCode,
        vacancy: vacnacyIdCod,
      };
    }
    if (type == 2) {
      body = {
        type: type,
        vacancy: vacancyId,
        user: getUser().id,
        modalCVAutoHCode: modalCVAutoHCode,
      };
    }

    execSelectionOptions(id, body)
      .then(() => {
        type == 1 && handleModalNoProfile(false);
        type == 2 && handleModalSelectCan(false);

        type == 1 && snackbar.success("Candidato setado para SEM PERFIL");
        type == 2 && snackbar.success("Candidato SELECIONADO");

        type == 1 && setNoProfileArray([...noProfileArray, id]);
        type == 2 && setSelectedArray([...selectedeArray, id]);

        // Se for da aba ML e o candidato foi selecionado, atualiza o status
        if (isMLTab && type == 2 && id && onMLCandidateProcessed) {
          onMLCandidateProcessed(id);
        }
      })
      .catch(() => {
        snackbar.error("ERRO");
        type == 1 && handleModalNoProfile(false);
        type == 2 && handleModalSelectCan(false);
      });
  };
  const [contentToPrint, setContentToprint] = useState<
    React.MutableRefObject<null>
  >(useRef(null));

  const setRef = (ref: React.MutableRefObject<null>) => {
    console.log(ref);
    setContentToprint(ref);
  };

  const handlePrint = useReactToPrint({
    content: () => contentToPrint.current,
  });

  return (
    <>
      <ModalNoProfile
        description="Deseja colocar o candidato em SEM PERFIL?"
        pending={false}
        onClose={() => handleModalNoProfile(false)}
        onConfirm={handleExecSele}
        open={modalNoProfile}
        title="Candidato Sem Perfil"
        id={canId}
        modalCVAutoHCode={modalCVAutoHCode}
      />
      <ModalSelectCan
        description="Deseja SELECIONAR o candidato?"
        pending={false}
        onClose={() => handleModalSelectCan(false)}
        onConfirm={handleExecSele}
        open={modalSelectCan}
        title="Selecionar Candidato"
        id={canId}
        vacancyId={vacancyId}
        modalCVAutoHCode={modalCVAutoHCode}
      />

      <ModalSendCandidateToVacancy
        description="Deseja encaminhar o candidato para qual vaga?"
        pending={false}
        onClose={() => handleModalSendCanidateToVacancy(false)}
        onConfirm={() => undefined}
        open={modalSendCanidateToVacancy}
        title="Encaminhar Candidato"
        id={canId}
        modalCVAutoHCode={modalCVAutoHCode}
        onSuccess={() => {
          // Se for da aba ML, atualiza o status quando encaminhar
          if (isMLTab && canId && onMLCandidateProcessed) {
            onMLCandidateProcessed(canId);
          }
        }}
      />
      {!reload && (
        <Dialog
          open={open}
          onClose={onClose}
          aria-labelledby="user-dialog-title"
          scroll="paper"
          maxWidth="sm"
          hideBackdrop
          fullScreen
          className={`${
            slideFromLeft ? "modalSelectionCvLeft" : "modalSelectionCv"
          } fadeInRight`}
        >
          <div style={{ backgroundColor: "#edeff1", position: "relative" }}>
            <DialogContent style={{ height: "calc(100vh - 93px)" }}>
              <Carousel
                isRTL={false}
                itemPosition="center"
                initialFirstItem={indexState}
                //initialActiveIndex={indexState}
                renderPagination={({
                  pages,
                  activePage,
                  onClick,
                }: RenderPaginationProps) => {
                  return (
                    <>
                      <Grid container direction="row" justifyContent="center">
                        {initState.length <= 18 && (
                          <Paper
                            style={{
                              backgroundColor: "#FFF",
                              position: "fixed",
                              top: 18,
                              zIndex: 4,
                              borderRadius: 7,
                            }}
                          >
                            {pages.map((page: any) => {
                              const isActivePage = activePage === page;
                              return (
                                <IconButton
                                  key={page}
                                  onClick={() => onClick(page)}
                                >
                                  {isActivePage ? (
                                    <Adjust color="primary" />
                                  ) : (
                                    <Circle
                                      color="primary"
                                      sx={{ fontSize: 12, m: 0.8 }}
                                    />
                                  )}
                                </IconButton>
                              );
                            })}
                          </Paper>
                        )}
                      </Grid>
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        sx={{ p: 2 }}
                      >
                        <div className="selectionNames">
                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                          >
                            <Grid item md={4} xs={4} className="hiddenText">
                              {renderPrev(activePage, initState)}
                            </Grid>
                            <Grid
                              item
                              md={4}
                              xs={4}
                              className="adjustPadding hiddenText"
                            >
                              {renderActive(activePage)}
                            </Grid>
                            <Grid
                              item
                              md={4}
                              xs={4}
                              className="adjustPaddingRight hiddenText"
                            >
                              {renderNext(activePage, initState)}
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    </>
                  );
                }}
                renderArrow={({ type, onClick }: RenderArrowProps) => (
                  <div onClick={onClick} className={classes.arrows}>
                    {type === "PREV" ? (
                      <IconButton
                        ref={buttonRefLeft}
                        className={classes.arrowsLeft}
                      >
                        <ArrowCircleLeft sx={{ fontSize: 60 }} />
                      </IconButton>
                    ) : (
                      <IconButton
                        ref={buttonRefRigtht}
                        className={classes.arrowsRight}
                      >
                        <ArrowCircleRight sx={{ fontSize: 60 }} />
                      </IconButton>
                    )}
                  </div>
                )}
              >
                {initState.map((item) => {
                  return (
                    <div
                      key={item.id}
                      style={
                        canId == item.id
                          ? {
                              backgroundColor: "white",
                              borderTopLeftRadius: 10,
                              borderTopRightRadius: 10,
                              marginTop: 30,
                              boxShadow: "0px 2px 29px 7px rgba(0,0,0,0.29)",
                            }
                          : { height: "964px" }
                      }
                    >
                      {canId == item.id && (
                        <Curricullum
                          canId={item.id}
                          data={pessoalData}
                          observ={obse}
                          noProfile={noProfileArray}
                          selectedsCan={selectedeArray}
                          isLoadingCV={isLoadingCV}
                          setRef={(ref) => setRef(ref)}
                        />
                      )}
                    </div>
                  );
                })}
              </Carousel>
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={1}
                direction="row"
                justifyContent="space-between"
              >
                <Grid item xs={1} md={1}>
                  <Tooltip title="Fechar" disableInteractive>
                    <Button
                      style={{
                        backgroundColor: "red",
                        fontSize: "16px",
                      }}
                      onClick={onClose}
                      fullWidth
                      variant="contained"
                      size="small"
                    >
                      <Close />
                    </Button>
                  </Tooltip>
                </Grid>
                <Grid item xs={1} md={1}>
                  <Tooltip title="Imprimir" disableInteractive>
                    <Button
                      color="primary"
                      fullWidth
                      size="small"
                      variant="contained"
                      onClick={() => {
                        handlePrint(null, () => contentToPrint.current);
                      }}
                    >
                      <Print />
                    </Button>
                  </Tooltip>
                </Grid>
                <Grid item xs={1} md={1}>
                  <Tooltip title="Enviar E-mail" disableInteractive>
                    <Button
                      color="secondary"
                      fullWidth
                      size="small"
                      variant="contained"
                    >
                      <Mail />
                    </Button>
                  </Tooltip>
                </Grid>
                <Grid item xs={1} md={1}>
                  <NavLink
                    style={{
                      color: "#000000",
                    }}
                    to={`/admin/candidate/` + canId}
                    color="inherit"
                    target="_blank"
                  >
                    <Button
                      color="primary"
                      fullWidth
                      size="small"
                      variant="outlined"
                    >
                      Editar
                    </Button>
                  </NavLink>
                </Grid>
                <Grid item xs={2} md={2}>
                  <Button
                    color="primary"
                    fullWidth
                    size="small"
                    endIcon={obse ? <Visibility /> : <VisibilityOff />}
                    variant={obse ? "contained" : "outlined"}
                    onClick={() => handleObse(!obse)}
                  >
                    Observações
                  </Button>
                </Grid>
                <Grid item xs={2} md={2}>
                  <Button
                    color="primary"
                    fullWidth
                    variant="outlined"
                    size="small"
                    onClick={() => handleModalNoProfile(true)}
                  >
                    Sem Perfil
                  </Button>
                </Grid>
                <Grid item xs={2} md={2}>
                  <Button
                    color="primary"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onClick={() => handleModalSelectCan(true)}
                  >
                    Selecionar
                  </Button>
                </Grid>
                <Grid item xs={2} md={2}>
                  <Button
                    color="primary"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onClick={() => handleModalSendCanidateToVacancy(true)}
                  >
                    Encaminhar
                  </Button>
                </Grid>
              </Grid>
              {/*  <LoadingButton loading={processing} type="submit" variant="contained">
            {editMode
              ? t("userManagement.modal.edit.action")
              : t("userManagement.modal.add.action")}
          </LoadingButton> */}
            </DialogActions>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default ModalCVSelection;
